/**
 * module 下拉框多选模板
 * createdBy he.zhikai
 * createdIn 2017-03-08
 */
'use strict';
angular.module('util.trsMultiSelection', []).
directive('trsMultiSelection', ['$timeout', function($timeout) {
    return {
        scope: {
            callback: "&", //回调函数
            options: "=", //下拉框数据
            selectedOptions: "=", //已选中数据
            namekey: "@", //显示的字段
            placeHolder: "@", //未选中数据时显示的内容
        },
        restrict: 'E',
        templateUrl: './components/util/trsMultiSelection/trsMultiSelection_tpl.html',
        link: function(scope, element, attrs, controller) {
            initStatus();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    showOptionList: false, //是否显示下拉框
                };
                //点击该组件以外的其他元素时隐藏下拉框
                $("*").click(function(event) {
                    if (!($(this).closest('.trsMultiSelection').length !== 0)) {
                        element.find('#trsMultiSelection_options').fadeOut();
                        scope.status.showOptionList = false;
                    } else if (!($(this).closest('.trsMultiSelection_ul').length !== 0)) {
                        //点击该组件内已选数据所在的ul元素时，阻止事件冒泡，以防止下拉框显示和隐藏异常
                        event.stopPropagation();
                    }
                });
                //若初始化时已有选中的数据，则自动根据数据数量拉伸div高度
                /*let height = (scope.selectedOptions.length == 0 ? 40 : (scope.selectedOptions.length) * 37 + 3)+'px';
                element.find('#trsMultiSelection_selectedArea').css({
                    height: height,
                    lineHeight: height
                });*/
            }

            /**
             * [showOptionList description] 显示或隐藏下拉框
             * @return {[type]} [description]
             */
            scope.showOptionList = function() {
                if (scope.status.showOptionList === true) {
                    element.find('#trsMultiSelection_options').fadeOut();
                    scope.status.showOptionList = false;
                } else {
                    element.find('#trsMultiSelection_options').fadeIn();
                    scope.status.showOptionList = true;
                }
            };

            /**
             * [setSelected description] 选中或移除下拉框数据
             * @param {[type]} option [description]
             */
            scope.setSelected = function(option) {
                if (scope.selectedOptions.indexOf(option) >= 0) {
                    scope.selectedOptions.splice(scope.selectedOptions.indexOf(option), 1);
                    //选中或移除下拉框数据时自动调整div高度
                    /*let height = (scope.selectedOptions.length == 0 ? 40 : (scope.selectedOptions.length) * 37 + 3)+'px';
                    element.find('#trsMultiSelection_selectedArea').css({
                        height: height,
                        lineHeight: height
                    });*/
                    $timeout(function() {
                        scope.callback();
                    });
                } else {
                    /*let height = ((scope.selectedOptions.length + 1) * 37 + 3)+'px';
                    element.find('#trsMultiSelection_selectedArea').css({
                        height: height,
                        lineHeight: height
                    });*/
                    scope.selectedOptions.push(option);
                    $timeout(function() {
                        scope.callback();
                    });
                }
            };

            /**
             * [setDelete description] 移除下拉框数据
             * @param {[type]} selectedOption [description]
             * @param {[type]} ev             [description]
             */
            scope.setDelete = function(selectedOption, ev) {
                //阻止事件冒泡，点击删除时不显示下拉框
                ev.preventDefault();
                ev.stopPropagation();
                scope.selectedOptions.splice(scope.selectedOptions.indexOf(selectedOption), 1);
                /*let height = (scope.selectedOptions.length == 0 ? 40 : (scope.selectedOptions.length) * 37 + 3)+'px';
                element.find('#trsMultiSelection_selectedArea').css({
                    height: height,
                    lineHeight: height
                });*/
                $timeout(function() {
                    scope.callback();
                });
            };
        }
    };
}]);